import { useOutletContext } from "react-router-dom";
import { useData } from "../../context/DataContext";
import { C, SC } from "../../styles/theme";
import Badge from "../../components/common/Badge";
import { Th, Td, ABt, filt, exportCSV, genInvoice } from "../AdminUI";

export default function OrdersTab() {
  const { db, saveDB } = useData();
  const { toast, srch } = useOutletContext();
  const save = r => { saveDB("orders", r); toast("Updated"); };

  return (
    <>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
        <div style={{ fontSize: 13, color: "#64748b" }}>Manage orders and generate GST-compliant invoices.</div>
        <ABt variant="orange" onClick={() => exportCSV("orders", db.orders || [], [["Order ID", "id"], ["Customer", "customer"], ["Email", "email"], ["Product", "product"], ["Qty", "qty"], ["Amount", "amount"], ["Status", "status"], ["Date", "date"]], toast)}>Export CSV</ABt>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(220px,1fr))", gap: 11, marginBottom: 14 }}>
        {["pending", "processing", "shipped", "delivered"].map(st => (
          <div key={st} style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 10, padding: "12px 14px", textAlign: "center", boxShadow: "0 2px 5px rgba(0,0,0,.04)" }}>
            <div style={{ fontSize: 22, fontWeight: 800, color: (SC[st] || {}).c || C.blue }}>{(db.orders || []).filter(o => o.status === st).length}</div>
            <div style={{ fontSize: 11, color: "#64748b", marginTop: 2, textTransform: "capitalize", fontWeight: 600 }}>{st}</div>
          </div>
        ))}
      </div>
      <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 11, overflow: "auto", boxShadow: "0 2px 6px rgba(0,0,0,.04)" }}>
        <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 700 }}>
          <thead><tr>{["Order ID", "Customer", "Product", "Qty", "Amount", "Status", "Update", "Invoice"].map(h => <Th key={h}>{h}</Th>)}</tr></thead>
          <tbody>
            {filt(db.orders, ["id", "customer", "status"], srch).map(o => (
              <tr key={o.id}>
                <Td bold blue>{o.id}</Td>
                <Td bold>{o.customer}</Td>
                <Td>{o.product}</Td>
                <Td>{o.qty}</Td>
                <Td bold>Rs.{o.amount.toLocaleString()}</Td>
                <Td><Badge v={o.status} /></Td>
                <td style={{ padding: "9px 11px", borderBottom: "1px solid #f1f5f9" }}>
                  <select value={o.status} onChange={e => save({ ...o, status: e.target.value })} style={{ padding: "4px 7px", border: "1.5px solid #e2e8f0", borderRadius: 6, fontSize: 12, cursor: "pointer", background: "#f8fafc" }}>
                    {["pending", "processing", "shipped", "delivered"].map(st => <option key={st} value={st}>{st}</option>)}
                  </select>
                </td>
                <td style={{ padding: "9px 11px", borderBottom: "1px solid #f1f5f9" }}>
                  <ABt variant="green" onClick={() => genInvoice(o, db.settings, toast)}>Invoice</ABt>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
